import { jsx } from "react/jsx-runtime";
import { B as Button } from "./Button-BduN4i4I.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import "./Grid-CcQKdsgp.js";
const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  itemsPerPage,
  renderPageLabel = (page) => `${page * itemsPerPage + 1} - ${(page + 1) * itemsPerPage}`
}) => {
  if (totalPages <= 1) return null;
  return /* @__PURE__ */ jsx(Flex, { gap: 10, justify: "center", m: { mt: 16 }, md: { m: { mt: 24 } }, children: Array.from({ length: totalPages }, (_, i) => /* @__PURE__ */ jsx(
    Button,
    {
      minWidth: "fit-content",
      variant: "secondary",
      size: "xsmall",
      p: { px: 24, py: 8 },
      md: {
        p: { px: 24, py: 8 },
        fontSize: "button.desktop.small",
        lineHeight: "button.desktop.small"
      },
      className: `rounded ${currentPage === i ? "outline outline-1 outline-[var(--colors-text-selection)] text-[var(--colors-text-selection)]" : ""}`,
      onPress: () => onPageChange(i),
      children: renderPageLabel(i)
    },
    i
  )) });
};
export {
  Pagination as P
};
